module.exports = "<div class=\"text-center pb-sm range-box\">\n  <span class=\"pull-left\"></span> - <span class=\"pull-right\"></span>\n</div>\n";
